import React from 'react';
import SideNav from './sidenav';
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import './documentation.scss';
const Documentation = ({ content }) => {
    const sections = content && !!content.documentation.length && content.documentation.map((obj, index) => {
        return {
            ...obj,
            id: obj.title && obj.title.toLowerCase().replaceAll(" ", "-")
        };
    });

    const sectionIDs = sections.map(obj => obj.id);

    return (
        <div className="documentation-pg">

            <div className="documentatiop-wrap " id="documentatiop-wrap">
                {/* mobile sidenav section start */ }
                <div className="mobilesidenav" id="mobilesidenav">
                    <div className="inner-box">
                        <SideNav sections={ sections } sectionIDs={ sectionIDs } />
                    </div>
                </div>
                {/* mobile sidenav section end */ }


                <div className="container">
                    <div className="row-wrap mx-0 sticky-parent">
                        <div className="side-nav" id="side-nav">
                            <SideNav sections={ sections } sectionIDs={ sectionIDs } />
                        </div>
                        <div className="nav-content content-box">
                            {
                                sections && !!sections.length && sections.map((obj, index) => {
                                    return (
                                        <section id={ obj.id } key={ obj.id }>
                                            <div className="inner-box" dangerouslySetInnerHTML={ { __html: obj.content } }>
                                            </div>
                                            {
                                                index === 0 && obj.scroll_content && <PerfectScrollbar component='div'
                                                    // className="slideBg"
                                                    options={ {
                                                        wheelSpeed: 0.8,
                                                        wheelPropagation: true,
                                                        minScrollbarLength: 20,
                                                        swipeEasing: true,
                                                        handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
                                                    } }>
                                                    <div dangerouslySetInnerHTML={ { __html: obj.scroll_content } }>
                                                    </div>
                                                </PerfectScrollbar>
                                            }
                                        </section>
                                    );
                                })
                            }
                            {/* <section id="section-1">
                                <div className="inner-box">
                                    <h1>Developer portal documentation</h1>
                                    <h2>Welcome page</h2>
                                    <h5>Welcome to DEMIVOLT Open Banking Developer portal</h5>
                                    <p>Here you can find available API list relevant for PSD2 compliant APIs. Use interactive swagger documentation or download it for offline usage. Download Swagger file and test it.</p>

                                    <h5>Environment URLS:</h5>
                                    <ul>
                                        <li>SandBox (Test): [bank url]/</li>
                                        <li>Live (Prod): [bank url]/</li>
                                    </ul>
                                    <h5>Sandbox data</h5>
                                    <p> You are able to test APIs containing data of PSU accessing both private individual and corporate accounts, different types of transactions and get confirmation of available funds. All Sandbox data is fake, it doesn’t contain real customers’ data.</p>
                                    <h5>Versions History and Roadmap</h5>

                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Version</th>
                                                <th>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>2019-03-01</td>
                                                <td>V1.0</td>
                                                <td>Initial version</td>
                                            </tr>
                                            <tr>
                                                <td>2020-09-14</td>
                                                <td>V2.0</td>
                                                <td>Alignment witd Berlin Group v1.3 specification</td>
                                            </tr>
                                            <tr>
                                                <td>2021-Q1</td>
                                                <td>V3.0 (Planned)</td>
                                                <td>SCA autdentification</td>
                                            </tr>
                                            <tr>
                                                <td>2019-03-01</td>
                                                <td>V1.0</td>
                                                <td>Initial version</td>
                                            </tr>

                                        </tbody>
                                    </table>

                                </div>
                            </section> */}
                            {/* <section id="section-2">
                                <div className="inner-box">
                                    <h2>Get access to DEMIVOLT PSD2 APIs</h2>
                                    <h5>STEP 1:</h5>
                                    <p>Write email to our back office openbanking@demivolt.com providing this information:</p>
                                    <ul>
                                        <li>TPP Company name</li>
                                        <li>TPP Company code</li>
                                        <li>TPP Company description</li>
                                        <li>Developer name and surname</li>
                                        <li>Developer user name</li>
                                    </ul>
                                    <h5>STEP 2:</h5>
                                    <p>Go through API documentation</p>
                                    <h5>STEP 3:</h5>
                                    <p>Make sure you have the required local PISP and/or AISP license.</p>
                                    <h5>STEP 4:</h5>
                                    <p>Make sure you test your app, and go live.</p>
                                </div>
                            </section>
                            <section id="section-3">
                                <div className="inner-box">
                                    <h2>General Information</h2>
                                    <h5>Terminology</h5>

                                    <dl>
                                        <dd><i>Berlin Group</i> – a pan-European payments interoperability standards and harmonisation initiative. Our API’s are created under Berlin Group specification.</dd>
                                        <dd><i>PSD2</i> – Payments Systems Directive 2.</dd>
                                        <dd><i>PSU</i> – Payment Service User.</dd>
                                        <dd><i>TPP</i> – Third Party Provider in context with above directive and standards.</dd>
                                        <dd><i>ASPSP</i> - Account Servicing Payment Service Providers</dd>
                                        <dd><i>SCA</i> - Strong customer authentification.</dd>
                                        <dd><i>PISP</i> - Payment Initiation Service Provider.</dd>
                                    </dl>

                                    <h5>Short API description</h5>
                                    <p>RESTful APIs with json format messages. Solution for third party application providers who would like to build applications on top DEMIVOLT APIs mainly for private individuals and SMEs. In this portal as developer you can find APIs for:</p>

                                    <p><strong>Consents managements.</strong> The Accounts balances API allows your customers to manage consents from your service, with SCA in their bank. Methods which are available:</p>
                                    <ul>
                                        <li>Create consent</li>
                                        <li>View consent</li>
                                        <li>Cancel consent</li>
                                    </ul>

                                    <p><strong>Accounts balances.</strong> The Accounts balances API allows your customers to view accounts and their balances from your service. Information which is available:</p>

                                    <ul>
                                        <li>Account list </li>
                                        <li>Account balance of payment account</li>
                                    </ul>
                                    <h5>Transactions information</h5>
                                    <ul>
                                        <li>Statements per account and per currency </li>
                                        <li>Fund confirmation service</li>
                                    </ul>
                                    <p><strong>Payments initiation.</strong> The Payment Initiation API allows your customers to make payments from your service. Payment types which are available:</p>

                                    <ul>
                                        <li>SEPA payments  </li>
                                        <li>Instant payments</li>
                                        <li>International payments.</li>
                                    </ul>
                                    <h5>TPP information</h5>
                                    <p>Client (TPP) ID is needed to perform API calls. </p>
                                    <p>After Sign Up your Client (TPP) profile is pre-generated for you, but for easier user experience in the Portal this is done in background. For testing authentication flow outside Portal TPP ID is created and can be copied for later use.</p>
                                    <h5>PSU Consent</h5>
                                    <p>For the account information services (except list of accounts) explicit PSU Consent should be given. Consent is created using Consents endpoints. It should contain:</p>
                                    <p>- Access permissions: accounts, balances, transactions; Permissions are marked in scope. Possible scenarios:</p>

                                    <ul>
                                        <li>A - Accounts</li>
                                        <li>A+B - Accounts with Balances</li>
                                        <li>A+B+T - accounts with balances and transactions</li>
                                    </ul>
                                    <p>- Array of accessible accounts (IBANs); </p>
                                    <p>- Validity term: max 90 days after creation;</p>
                                    <h5>Detailed API description (API Catalog)</h5>
                                    <p>More detailed documentation for PSU consent is provided in API Catalog: <a href="#">https://psd2-docs.demivolt.com/app/apis</a>.</p>
                                </div>
                            </section>
                            <section id="section-4">
                                <div className="inner-box">
                                    <h2>Support template</h2>
                                    <h5>Support</h5>
                                    <p>For support please forward your questions to <a href="#">support@demivolt.com</a></p>
                                </div>
                            </section> */}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Documentation;